export enum BroadcastEvents {
    reloadData = 'reloadData',
    networkStateChanged = 'networkStateChanged'
}
